module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_001.png
// module id = 2348
// module chunks = 5